import { render, staticRenderFns } from "./AgentInviteRecord.vue?vue&type=template&id=02612074"
import script from "./AgentInviteRecord.vue?vue&type=script&lang=js"
export * from "./AgentInviteRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports